var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import api from './api';
import { RECEIPTS_URL } from './constants';
import { useMutation, useQuery } from 'react-query';
export const fetchReceipt = (uid) => __awaiter(void 0, void 0, void 0, function* () {
    const result = yield api.get(`${RECEIPTS_URL}/${uid}`);
    return result.data;
});
export function useGetReceipt(props) {
    const uid = props.uid;
    return useQuery(['receiptDetails', { uid }], () => fetchReceipt(uid), Object.assign({ enabled: !!uid }, props === null || props === void 0 ? void 0 : props.options));
}
export function useSearchReceipt(props) {
    return useMutation(['receiptUid'], (data) => __awaiter(this, void 0, void 0, function* () {
        // Formats the date in required format before sending to backend
        const formattedDate = new Date(data.date).toISOString().split('T')[0].toString();
        const result = yield api.post(RECEIPTS_URL, Object.assign(Object.assign({}, data), { date: formattedDate }));
        return result.data;
    }), props === null || props === void 0 ? void 0 : props.options);
}
